export abstract class AbstractLocalStorageService {
  protected getItem(key: string): string {
    return localStorage.getItem(key);
  }

  protected setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  protected removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
